import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-module',
  templateUrl: './master-module.component.html',
  styleUrls: ['./master-module.component.scss']
})
export class MasterModuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
